import { Component } from "react"

/* Modal */
import Modal from "react-modal"

/* Redux */
import { connect } from "react-redux"

/* Icons */
import { CloseIcon, PauseIcon, ArrowUpRightIcon } from "../../components/Icons"

/* Helpers */
import { utils } from "../../helpers"

/* Constants */
import { sound } from "../../constants"

/* Translate */
import { t } from "../../translates/translate"

/* Moment */
import moment from "moment"
import "moment/locale/ru"


/* THE NUMBER OF PAUSES THE PANEL KEEPS — AN OLDER ONE IS NOT WORTH A ROW */
const MAX = 12


/* Widget Pause */
class Pause extends Component {

    constructor() {
        super()

        this.state = {
            visible: false,
            list: [],
        }

        this._audio = null
    }

    componentWillUnmount = () => {
        this.stop()
    }


    /* Push A Pause — THE ALERT OPENS AND SOUNDS ON EVERY SINGLE EVENT */
    push = (item) => {

        /* Check Item */
        if (!item) {
            return
        }

        /* Open Modal */
        this.setState((state) => ({ visible: true, list: [item, ...state.list].slice(0, MAX) }))

        /* Play Sound */
        this.play()
    }

    /* Close — the queue is dropped after the closing transition, not in the middle of it */
    close = () => {

        /* Stop Sound */
        this.stop()

        /* Close Modal */
        this.setState({ visible: false })
    }


    /* Play The Alert */
    play = () => {

        /* Stop The Running One — a second pause never overlaps the first */
        this.stop()

        /* Play Sound */
        this._audio = sound.play("pause")
    }

    /* Stop The Alert */
    stop = () => {

        /* Check Audio */
        if (!this._audio) {
            return
        }

        try {
            this._audio.stop()
        }
        catch {
            /* Skip */
        }

        this._audio = null
    }


    /* Go To The Table */
    go = (item) => {

        /* Fields */
        const { navigate } = this.props

        /* Check Table */
        if (!item || !item.game || !item.uid) {
            return
        }

        /* Close Panel */
        this.close()

        /* Open Table */
        if (navigate) {
            navigate(`/table/${item.game}/${item.uid}`)
        }
    }


    /* TITLE OF A GAME — THE KEY OF THE TABLE IS THE ONLY SOURCE, THE NAME COMES FROM THE CATALOGUE */
    title = (key) => {

        /* Fields */
        const { catalog } = this.props
        const game = catalog.games.find((item) => item.key === key)

        /* Send Result */
        return game ? game.name : utils.checkValue(key, "—")
    }


    /* Draw Icon */
    _icon = () => (
        <div className="pause--icon">
            <span className="pause--ring one" />
            <span className="pause--ring two" />
            <div className="pause--icon-box"><PauseIcon size={26} /></div>
        </div>
    )


    /* Draw Table */
    _table = (item) => (
        <div className="pause--table">

            <div className="pause--table-name">{utils.checkValue(item.name, "—")}</div>
            <div className="pause--table-game">{this.title(item.game)}</div>

            <div className="pause--chips">
                {item.slug && <span className="pause--chip">{item.slug}</span>}
                <span className="pause--chip time">{moment(item.createdAt).format("HH:mm:ss")}</span>
            </div>

        </div>
    )


    /* Draw The Rest — EVERY PAUSE THAT CAME WHILE THE ALERT WAS ALREADY OPEN */
    _rest = (list) => {

        /* Check List */
        if (list.length === 0) {
            return null
        }

        return (
            <div className="pause--rest">

                <div className="pause--rest-title">{`${t("notification.alsoPaused")} · ${list.length}`}</div>

                {list.map((item, index) =>
                    <div onClick={() => this.go(item)} className="pause--rest-item" key={`${index}`}>

                        <div className="pause--rest-icon"><PauseIcon size={13} /></div>

                        <div className="pause--rest-text">
                            <b>{utils.checkValue(item.name, "—")}</b>
                            <span>{this.title(item.game)}</span>
                        </div>

                        <div className="pause--rest-time">{moment(item.createdAt).format("HH:mm")}</div>

                    </div>
                )}

            </div>
        )
    }


    render = () => {

        /* Fields */
        const { visible, list } = this.state

        /* Fields */
        const current = list.length > 0 ? list[0] : null

        /* Check Pause */
        if (!current) {
            return null
        }

        return (
            <Modal
                isOpen={visible}
                onRequestClose={() => this.close()}
                onAfterClose={() => this.setState({ list: [] })}
                className="pause--modal"
                overlayClassName="pause--overlay"
                closeTimeoutMS={220}
            >

                <div onClick={() => this.close()} className="pause--close">
                    <CloseIcon size={13} />
                </div>

                <div className="pause--head">

                    {/* Draw Icon */}
                    {this._icon()}

                    <h2>{t("notification.pauseTitle")}</h2>
                    <p>{t("notification.pauseText")}</p>

                </div>

                <div className="pause--body">

                    {/* Draw Table */}
                    {this._table(current)}

                    {/* Draw The Rest */}
                    {this._rest(list.slice(1))}

                </div>

                <div className="pause--footer">

                    <div onClick={() => this.close()} className="pause--button ghost">{t("common.close")}</div>

                    <div onClick={() => this.go(current)} className="pause--button">
                        <span>{t("notification.goTable")}</span>
                        <ArrowUpRightIcon size={14} />
                    </div>

                </div>

            </Modal>
        )
    }

}

const mapStateToProps = (state) => ({
    language: state.language,
    catalog: state.catalog,
})

export default connect(mapStateToProps, null, null, { forwardRef: true })(Pause)
